<template>
  <div>
    <button :disabled="game === null" @click="printMoves">Print Moves</button>
  </div>
</template>

<script>
import Game from '@/game/Game';

export default {
  name: 'DebugTool',

  props: {
    game: {
      type: Game,
      required: false,
    }
  },

  methods: {
    printMoves() {
      for(const m of this.game.moves) {
        console.log(JSON.stringify(m));
      }
    }
  },
}
</script>

<style scoped>
</style>
